/*
* config.js
*
* Description: config.js
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Hotels"
* Copyright 2018,2019,2020, 2021  Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
/******************************************************************************* 'ENV/CLIENT'
* Config: 'CONF_ENVIRONMENT', 'CONF_CLIENT'
*
* Note: 'Sundair', 'Flyair41'
*
*/
export let CONF_ENVIRONMENT = 'PROD'; // DEV || PROD
export const CONF_CLIENT = 'Flyair41'; // 'Sundair', 'Flyair41'




/*******************************************************************************
* Config: CONF_CLIENT_LOGO'
*
* Note:
*
*/
export const CONF_CLIENT_LOGO = CONF_CLIENT === 'Sundair' ? 'https://sundair.com/res/images/logo.png' : 'https://directbooking.flyair41.de/res/images/sdr140x30.png';

/*******************************************************************************
* Config: CONF_CLIENT_URL'
*
* Note:
*
*/
export const CONF_CLIENT_URL = CONF_CLIENT === 'Sundair' ? 'https://www.sundair.com' : 'https://www.flyair41.com';
export const CONF_CLIENT_URL_WRITTEN = CONF_CLIENT === 'Sundair' ? 'www.sundair.com' : 'www.flyair41.com';

export const CONF_CLIENT_URL_APPS = CONF_CLIENT === 'Sundair' ? 'https://apps.sundair.com' : 'https://www.flyair41.com';
export const CONF_CLIENT_URL_APPS_WRITTEN = CONF_CLIENT === 'Sundair' ? 'apps.sundair.com' : 'apps.flyair41.com';

/*******************************************************************************
* Config: CONF_CLIENT_URLS' - SC'
*
* Note: 'CALENDAR'
*
*/
export const CONF_CLIENT_URLS_SC2_FLIGHTS_PROD = CONF_CLIENT === 'Sundair' ? 'http://suncrew-flights.sundair.com/m' : 'http://suncrew-flights.flyair41.com/';
export const CONF_CLIENT_URLS_SC2_FLIGHTS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-flights.sundair.com/' : 'http://test-suncrew-flights.flyair41.com/';

export const CONF_CLIENT_URLS_SC2_CALENDAR_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-calendar.sundair.com' : 'https://suncrew-calendar.flyair41.com';
export const CONF_CLIENT_URLS_SC2_CALENDAR_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-calendar.sundair.com' : 'http://test-suncrew-calendar.flyair41.com';

export const CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-dutyplan.sundair.com' : 'https://suncrew-dutyplan.flyair41.com';
export const CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-dutyplan.sundair.com' : 'http://test-suncrew-dutyplan.flyair41.com';

export const CONF_CLIENT_URLS_SC2_PEOPLE_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-people.sundair.com' : 'https://suncrew-people.flyair41.com';
export const CONF_CLIENT_URLS_SC2_PEOPLE_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-people.sundair.com' : 'http://test-suncrew-people.flyair41.com';

export const CONF_CLIENT_URLS_SC2_HOTELS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-hotels.sundair.com' : 'https://suncrew-hotels.flyair41.com';
export const CONF_CLIENT_URLS_SC2_HOTELS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-hotels.sundair.com' : 'http://test-suncrew-hotels.flyair41.com';

export const CONF_CLIENT_URLS_SC2_VACATION_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-vacations.sundair.com' : 'https://suncrew-vacations.flyair41.com';
export const CONF_CLIENT_URLS_SC2_VACATION_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-vacations.sundair.com' : 'http://test-suncrew-vacations.flyair41.com';




/*******************************************************************************
* Config: 'FLAGS'
*
*/
export const CONF_AVAILABLE_FLAGS = ['SRB', 'RA', 'TG', 'ME', 'LA', 'MR', 'NI', 'LV', 'OM', 'AF', 'CY', 'BJ', 'AQ', 'CN', '_south-ossetia', '_nagorno-karabakh', 'CO', 'CX', 'AG', 'MS', 'MD', 'ZM', 'VN', 'TF', 'TD', 'YT', 'LB', 'MF', 'LU', 'MQ', 'CZ', 'AE', 'CM', 'BI', 'AR', '_wales', 'AS', 'BH', 'CL', 'AD', 'MP', 'LT', 'MG', 'LC', 'TR', 'UA', 'TV', 'VI', '_kosovo', 'MT', 'NO', 'MC', 'CH', 'BL', 'AW', '_northern-cyprus', '_somaliland', 'BZ', 'BM', 'CI', 'MU', 'US', 'TW', 'YE', 'MW', 'NL', 'LS', 'BO', 'AT', 'CK', '_united-nations', 'BY', 'AU', 'BN', 'MA', 'NZ', 'LR', 'MV', 'TC', 'UG', 'TT', 'PL', 'RS', 'IN', 'GE', 'GR', 'GS', '_scotland', 'GD', 'HK', 'KP', 'KG', 'SV', 'SA', 'SC', 'ST', 'KE', 'IM', 'KR', 'DJ', 'GQ', 'DK', 'GG', 'IL', 'PN', '_mars', 'SB', 'PY', 'RU', 'KW', 'DO', 'GT', '_unknown', 'GB', 'GU', 'JE', '_olympics', 'SG', 'PK', 'SR', '_england', 'SE', 'JP', 'GW', 'EH', 'DZ', 'GA', 'FR', 'DM', '_nato', 'HN', 'SD', 'RW', 'PH', 'SS', 'QA', 'PE', 'PR', 'SI', 'HT', 'ES', 'GL', 'GM', 'ER', 'FI', 'EE', 'KN', 'HU', 'IQ', 'KY', 'SH', 'PS', 'PF', '_red-cross', 'ID', 'IS', 'EG', 'FK', 'FJ', 'GN', 'GY', 'IR', 'KM', 'IE', 'KZ', 'RO', 'SK', 'PG', 'PT', 'SO', 'HR', 'KI', 'JM', 'EU', 'EC', 'ET', 'FO', 'KH', 'SY', 'SN', 'PW', 'SL', '_basque-country', 'FM', 'GI', 'DE', '_abkhazia', 'GH', 'IC', 'JO', 'IT', 'PA', 'SZ', 'SM', 'TN', 'ML', 'CG', 'AX', 'AO', 'BT', 'AN', 'BB', 'CF', 'MM', 'LI', 'NA', 'MZ', 'TO', 'VG', 'VE', 'TZ', 'TM', 'MX', 'NC', 'MO', 'LK', 'CD', 'AL', 'BW', '_british-antarctic-territory', 'CR', 'AM', 'AZ', 'BA', 'MN', 'NU', 'MY', 'TL', 'WS', 'TH', 'NF', 'LY', 'AI', 'BR', 'CV', 'BE', 'CA', 'BD', 'CW', 'BS', 'NG', 'MK', 'NP', 'VA', 'UZ', 'TK', 'VC', '_gosquared', 'ZW', 'NR', 'NE', 'CU', 'BF', '_commonwealth', 'BG', 'CC', 'MH', 'ZA', 'UY', 'WF', 'VU', 'TJ'];


/*******************************************************************************
* Config: 'API BASE URL'
*
*/
export const CONF_API_BASEURL = CONF_ENVIRONMENT === "PROD" ? "https://www.sundair.com/rest" : "http://test-crewplaning.sundair.com/rest";


/*******************************************************************************
* Config: 'Allowed - GRANT'
*
*/
export const CONF_NEEDED_PERMISSION = "sc2.people.admin";


/*******************************************************************************
* Config: 'VERSION/REVISION NUMBER'
*
*/
export const CONF_VERSION_NUMBER = "v2.0";
export const CONF_REVISIONS_NUMBER = "r.91";
